import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PUBLIC_API = process.env.REACT_APP_PUBLIC_API_URL || API;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  const status = e?.response?.status;
  if (typeof detail === "string" && !detail.includes("<")) return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (status === 429) return "Muitas tentativas. Aguarde alguns minutos e tente novamente.";
  if (status >= 500) return "Serviço temporariamente indisponível. Tente novamente em instantes.";
  if (status === 401) return "Sessão expirada. Faça login novamente.";
  return "Algo deu errado. Tente novamente.";
}

export const STATUS = {
  aberto: "Aberto",
  em_analise: "Em Análise",
  aguardando_cliente: "Aguardando Cliente",
  em_andamento: "Em Andamento",
  resolvido: "Resolvido",
  fechado: "Fechado",
};

export const PRIORITY = { baixa: "Baixa", media: "Média", alta: "Alta", critica: "Crítica" };

export const CATEGORY = {
  hardware: "Hardware",
  software_mobile: "Software Mobile",
  software_desktop: "Software Desktop",
  areas_locais: "Áreas e Locais",
  outros: "Outros",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  tenant_admin: "Gestor",
  agent: "Atendente",
  client: "Cliente",
};

export const STATUS_STYLE = {
  aberto: "text-emerald-400 bg-emerald-400/10",
  em_analise: "text-sky-400 bg-sky-400/10",
  aguardando_cliente: "text-amber-400 bg-amber-400/10",
  em_andamento: "text-indigo-400 bg-indigo-400/10",
  resolvido: "text-teal-400 bg-teal-400/10",
  fechado: "text-zinc-400 bg-zinc-400/10",
};

export const PRIORITY_STYLE = {
  baixa: "text-zinc-400 bg-zinc-400/10",
  media: "text-sky-400 bg-sky-400/10",
  alta: "text-amber-400 bg-amber-400/10",
  critica: "text-rose-400 bg-rose-400/10",
};

export function fileUrl(path) {
  return `${API}/files/${path}`;
}

export async function uploadFiles(files) {
  const paths = [];
  for (const f of files) {
    const fd = new FormData();
    fd.append("file", f);
    const { data } = await api.post("/upload", fd);
    paths.push(data.storage_path);
  }
  return paths;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

export function fmtDateShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit" }) +
    " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

export function elapsedOpen(createdIso, endIso) {
  const start = new Date(createdIso);
  const end = endIso ? new Date(endIso) : new Date();
  const ms = Math.max(0, end.getTime() - start.getTime());
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}min`;
  return `${minutes}min`;
}

export function homeFor(user) {
  if (!user) return "/login";
  if (user.role === "super_admin") return "/admin";
  if (user.role === "client") return "/portal";
  return "/app";
}

export const M_TIPO = { reclamacao: "Reclamação", elogio: "Elogio", sugestao: "Sugestão", manutencao: "Manutenção", solicitacao: "Solicitação", duvida: "Dúvida", outro: "Outro" };
export const M_TIPO_STYLE = { reclamacao: "text-rose-400 bg-rose-400/10", elogio: "text-emerald-400 bg-emerald-400/10", sugestao: "text-sky-400 bg-sky-400/10", manutencao: "text-amber-400 bg-amber-400/10", solicitacao: "text-indigo-400 bg-indigo-400/10", duvida: "text-violet-400 bg-violet-400/10", outro: "text-zinc-400 bg-zinc-400/10" };
export const M_STATUS = { aberto: "Aberto", em_analise: "Em Análise", em_andamento: "Em Andamento", resolvido: "Resolvido", cancelado: "Cancelado" };
export const M_STATUS_STYLE = { aberto: "text-rose-400 bg-rose-400/10", em_analise: "text-amber-400 bg-amber-400/10", em_andamento: "text-sky-400 bg-sky-400/10", resolvido: "text-emerald-400 bg-emerald-400/10", cancelado: "text-zinc-400 bg-zinc-400/10" };
export const M_PRIORITY = { baixa: "Baixa", media: "Média", alta: "Alta", urgente: "Urgente" };
export const M_PRIORITY_STYLE = { baixa: "text-zinc-400 bg-zinc-400/10", media: "text-sky-400 bg-sky-400/10", alta: "text-amber-400 bg-amber-400/10", urgente: "text-rose-400 bg-rose-400/10" };
export const AUDIT_ENTITY = { manifestacao: "Pedido/Ocorrência", aviso: "Aviso", chamado: "Chamado", horario: "Horário", reserva: "Reserva" };
export const R_STATUS = { confirmada: "Confirmada", concluida: "Concluída", cancelada: "Cancelada" };
export const R_STATUS_STYLE = { confirmada: "text-emerald-400 bg-emerald-400/10", concluida: "text-sky-400 bg-sky-400/10", cancelada: "text-zinc-400 bg-zinc-400/10" };
export const R_EVENTO = { festa: "Festa", reuniao: "Reunião", churrasco: "Churrasco", aniversario: "Aniversário", outro: "Outro" };
export const AUDIT_ACAO = { criado: "Inclusão", alterado: "Alteração", excluido: "Exclusão", cancelado: "Cancelamento", status_alterado: "Status alterado", parecer: "Parecer" };

export async function downscaleImage(file, maxSize = 1200) {
  if (!file.type.startsWith("image/") || file.type === "image/gif") return file;
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height));
  if (scale >= 1 && file.size < 300 * 1024) return file;
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.85));
  return new File([blob], file.name.replace(/\.\w+$/, ".jpg"), { type: "image/jpeg" });
}
